import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Row, Col, Container, Button, Modal } from "react-bootstrap";
import { useFormik  } from 'formik';
import * as Yup from 'yup';

import {
    copyRoom,
} from "services/school";
export default function CopyRoomModal(props) {
    const { roomId, open, onCloseModal, onCallBack } = props;
    const dispatch = useDispatch();
    const {
        copyRoom: { loading: isLoading },
      } = useSelector(({ school }) => school);
    const startRoomValues = {
        "name": ""
    }
    const [initialRoomValues, setInitialRoomValues] = useState(startRoomValues);

    
    
    const validationSchema = Yup.object().shape({
        name: Yup.string().required('This field is required.'),
    });
    
    

    const handleClose = () => {
        setInitialRoomValues(startRoomValues);
        onCloseModal();
        formik.handleReset()
    }

    const handleSubmit = async (values) => {
        const payload = {
            fromRoom: roomId,
            name: values.name
        }
        
        dispatch(copyRoom(payload, () => {
            onCallBack();
        }));
    }
    const formik = useFormik({
        initialValues: initialRoomValues,
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: handleSubmit
    });


    useEffect(() => {
        formik.handleReset()
    }, [open])
    return (
        <>
        <Modal
            onHide={onCloseModal}
            show={open}
            size="lg"
        >
        <Modal.Header className="mb-2 justify-content-center" >
            <Modal.Title className="text-capitalize">
                Copy Room
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3">
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <form onSubmit={formik.handleSubmit}>
                            <Form.Group>
                                
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formik.values.name}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                />

                                {formik.errors && formik.errors.name && <Form.Text className="text-danger">{formik.errors.name}</Form.Text>}
                            </Form.Group>
                        </form>
                    </Col>
                    <Modal.Footer className="p-0 pt-3 justify-content-between">
                        <Button variant="light" className="me-0 ms-auto btn-unset-height" onClick={handleClose} disabled={isLoading}>Close</Button> 
                        <Button onClick={formik.handleSubmit} disabled={isLoading}>Submit</Button> 
                    </Modal.Footer> 
                </Row>

            </Container>
        </Modal.Body>
        </Modal>
        </>
    );
}